import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { NotificationsCenter } from '@cp-mx/common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { fetchNotificationsAll } from './NotificationCenterSlice';
import { useNotificationsAllSelector } from './NotificationCenterSelector';

export function useNotificationCenter(): AbstractDataState<NotificationsCenter[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchNotificationsAll, useNotificationsAllSelector);
}
